<template>
  <div class="post-item" :data-id="post.id">
    <linkable-item
      v-if="post"
      :as="is"
      :target="post.link ? '_blank' : '_self'"
      :to="isPublic ? `/feed/post/${post.id}` : { query: { ...$route.query, postId: post.id } }"
      :href="post.link"
      rel="noopener noreferrer"
    >
      <div class="post">
        <img v-if="post.image" v-lazy="{ src: post.image }" />

        <div v-else-if="post.category" :class="['icon-wrapper', post.category.toLowerCase()]">
          <icon class="icon" :name="icon" />
        </div>

        <div class="post-content">
          <align flex direction="flex-start">
            <div class="post-title">{{ post.title }}</div>

            <icon-button
              v-if="isAdmin"
              tooltip="Delete post"
              icon="delete_outline"
              @click.stop.prevent="$emit('deletePost', post.id)"
            />
          </align>

          <p class="bottom-row">
            <span>{{ post.creator || 'Card Ladder' }}</span>
            <span>{{ timestamp }}</span>
          </p>
        </div>
      </div>
    </linkable-item>
  </div>
</template>

<script>
import moment from 'moment';

import Align from './Align';
import Icon from './Icon';
import IconButton from './IconButton';
import LinkableItem from './LinkableItem';

export default {
  components: {
    Align,
    Icon,
    IconButton,
    LinkableItem,
  },

  props: {
    post: Object,
    isPublic: Boolean,
    isAdmin: Boolean,
  },

  computed: {
    is() {
      if (this.post.link) return 'a';
      if (this.isPublic) return 'nuxt-link';
      return 'router-link';
    },

    timestamp() {
      return moment(this.post.date).fromNow();
    },

    icon() {
      switch (this.post.category) {
        case 'Headline':
          return 'title';

        case 'Sale':
          return 'attach_money';

        case 'Update':
          return 'get_app';

        case 'Card':
          return 'style';

        case 'Video':
          return 'play_arrow';

        case 'Podcast':
          return 'headset';

        default:
          return 'subject';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.post {
  width: 100%;
  display: flex;
  padding: $gp 0 0 $gp;

  img {
    object-fit: cover;
  }

  .icon-wrapper,
  img {
    width: 100px;
    height: 100px;
    margin-right: $gp;
    border-radius: $border-radius;
    margin-bottom: $gp;
    box-shadow: $elevation-1;

    @media($small-down) {
      width: 50px;
      height: 50px;
    }
  }

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .post-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    border-bottom: solid 1px var(--theme-border);
    padding: 0 $gp $gp 0;
  }

  .post-title {
    margin-bottom: $gp * .5;
    font-size: 24px;

    @media($medium-down) {
      font-size: 18px;
    }
  }

  .bottom-row {
    margin-top: auto;
    margin-bottom: 0;
    line-height: 1.2;
    display: flex;
    flex-direction: column;

    > * {
      margin-top: $gp * .25;
    }

    @media($medium-up) {
      flex-direction: row;
      align-items: flex-end;
      justify-content: space-between;
    }
  }
}

.icon-wrapper {
  .icon {
    color: $color-white;

    @media($small-up) {
      font-size: 48px;
    }
  }

  &.sale {
    background-color: $color-green-1;
  }

  &.article {
    background-color: $color-blue-1;
  }

  &.content {
    background-color: $color-yellow-1;
  }

  &.headline {
    background-color: $color-orange-1;
  }

  &.update {
    background-color: $color-purple-1;
  }

  &.card {
    background-color: $color-gray-5;
  }
}
</style>
